import {
  takeLatest, put, call, all,
} from 'redux-saga/effects';
import EmailVerificationService from '@rootCommon/services/email-verification-service';
import {
  resendEmailVerification as resendEmailVerificationAction,
  resendEmailInvitation as resendEmailInvitationAction,
} from '@actions';
import { IdType } from '@rootCommon/types/common';
import { AxiosError } from 'axios';
import { SagaGenerator } from './index';

function* resendEmailVerificationAsync(action: {
  payload: {
    id: IdType;
    prefix: string;
    routeExtension?: string;
  };
}) {
  try {
    yield call(
      EmailVerificationService.resendVerification,
      action.payload.id,
      action.payload.prefix,
      action.payload.routeExtension,
    );
    yield put(resendEmailVerificationAction.success());
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(resendEmailVerificationAction.failure(error));
  }
}

function* resendEmailInvitationAsync(action: {
  payload: {
    id: IdType;
    prefix: string;
    routeExtension?: string;
  };
}) {
  try {
    yield call(
      EmailVerificationService.resendInvitation,
      action.payload.id,
      action.payload.prefix,
      action.payload.routeExtension,
    );
    yield put(resendEmailInvitationAction.success());
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(resendEmailInvitationAction.failure(error));
  }
}

function* watchResendEmailVerification() {
  yield takeLatest(resendEmailVerificationAction.request, resendEmailVerificationAsync);
}

function* watchResendEmailInvitation() {
  yield takeLatest(resendEmailInvitationAction.request, resendEmailInvitationAsync);
}

// all
function* watchEmailVerification(): SagaGenerator {
  yield all([
    watchResendEmailVerification(),
    watchResendEmailInvitation(),
  ]);
}

export default watchEmailVerification;
